import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-sink-bathroom-icon"
};
const _hoisted_1 = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_3154_592)"><path opacity="0.4" d="M1.77783 13C1.77783 14.6568 3.12096 16 4.77783 16H12.7778C14.4347 16 15.7778 14.6568 15.7778 13V12H1.77783V13ZM16.2778 9H1.27783C1.00171 9 0.777832 9.22387 0.777832 9.5V10.5C0.777832 10.7761 1.00171 11 1.27783 11H16.2778C16.554 11 16.7778 10.7761 16.7778 10.5V9.5C16.7778 9.22387 16.554 9 16.2778 9Z"></path><path d="M11.7778 3.50004C11.7778 3.77617 12.0017 4.00004 12.2778 4.00004H13.2778C13.554 4.00004 13.7778 3.77617 13.7778 3.50004V3.00004C13.7778 1.1502 12.0951 -0.313866 10.1799 0.0581337C8.75568 0.334821 7.77783 1.66757 7.77783 3.11845V9.00004H9.77783V3.00004C9.77783 2.44876 10.2266 2.00004 10.7778 2.00004C11.3291 2.00004 11.7778 2.44876 11.7778 3.00004V3.50004ZM4.77783 6.50004H2.27783C2.00171 6.50004 1.77783 6.72385 1.77783 7.00004V7.50004C1.77783 7.77617 2.00171 8.00004 2.27783 8.00004H4.27783V9.00004H5.77783V7.50004C5.77783 6.94773 5.33014 6.50004 4.77783 6.50004ZM15.2778 6.50004H12.7778C12.2256 6.50004 11.7778 6.94773 11.7778 7.50004V9.00004H13.2778V8.00004H15.2778C15.554 8.00004 15.7778 7.77617 15.7778 7.50004V7.00004C15.7778 6.72385 15.554 6.50004 15.2778 6.50004Z"></path></g><defs><clipPath id="clip0_3154_592"><rect width="16" height="16" fill="white" transform="translate(0.777832)"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const uikitSinkBathroomIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitSinkBathroomIcon as default
};
//# sourceMappingURL=uikit-sink-bathroom-icon.vue.es.js.map
